export default __webpack_public_path__ + "static/media/appstore.8bfe0a4b.svg";